export const FILTERS_FORM = 'LISTS_FILTERS_FORM';
export const COLUMNS_FORM = 'LISTS_COLUMNS_FORM';

export const UNDEFINED_COLUMN_SECTION = 'UNDEFINED_COLUMN_SECTION';
